import requestService from '../../services/request.service';
const state = {
    idSolicitacao: '',
    codigoOrgaoSolicitante: '',
    nomeResponsavelSolicitacao: '',
    telefoneResponsavelSolicitacao: '',
    emailResponsavelSolicitacao: '',
    emailResponsavelSolicitacaoSecundario: '',
    indicadorSolicitacaoReordenamento: 'False',
    codigoTipoOrgaoSolicitante: '',
    tipoPerfilSolicitacao: '',
    codigoMotivoProcura: '',
    BreveRelato: '',
    status: '',
    errors: '',
    dataHoraSolicitacao: '',
    listCidadaos: [],
    list: [],
};

const getters = {
    listRequest: state => {
        return state.list;
    },
    getSavedIdRequest: state => {
        return state.idSolicitacao;
    },
    getReturnStatus: state => {
        return state.status;
    },
    getErrosOnSave: state => {
        return state.errors;
    }

};

const mutations = {
    save: (state, payload) => {
        state.idSolicitacao = payload.idSolicitacao;
        state.codigoOrgaoSolicitante = payload.codigoOrgaoSolicitante;
        state.nomeResponsavelSolicitacao = payload.nomeResponsavelSolicitacao;
        state.telefoneResponsavelSolicitacao = payload.telefoneResponsavelSolicitacao;
        state.emailResponsavelSolicitacao = payload.emailResponsavelSolicitacao;
        state.emailResponsavelSolicitacaoSecundario = payload.emailResponsavelSolicitacaoSecundario;
        state.indicadorSolicitacaoReordenamento = payload.indicadorSolicitacaoReordenamento;
        state.codigoTipoOrgaoSolicitante = payload.codigoTipoOrgaoSolicitante;
        state.tipoPerfilSolicitacao = payload.tipoPerfilSolicitacao;
        state.codigoMotivoProcura = payload.codigoMotivoProcura;
        state.BreveRelato = payload.BreveRelato;
        state.status = payload.status;
        state.dataHoraSolicitacao = payload.dataHoraSolicitacao;
        state.errors = payload.errors;
    },

    get: (state, payload) => {
        state.idSolicitacao = payload.idSolicitacao;
        state.codigoOrgaoSolicitante = payload.codigoOrgaoSolicitante;
        state.nomeResponsavelSolicitacao = payload.nomeResponsavelSolicitacao;
        state.telefoneResponsavelSolicitacao = payload.telefoneResponsavelSolicitacao;
        state.emailResponsavelSolicitacao = payload.emailResponsavelSolicitacao;
        state.emailResponsavelSolicitacaoSecundario = payload.emailResponsavelSolicitacaoSecundario;
        state.indicadorSolicitacaoReordenamento = payload.indicadorSolicitacaoReordenamento;
        state.codigoTipoOrgaoSolicitante = payload.codigoTipoOrgaoSolicitante;
        state.tipoPerfilSolicitacao = payload.tipoPerfilSolicitacao;
        state.codigoMotivoProcura = payload.codigoMotivoProcura;
        state.BreveRelato = payload.BreveRelato;
        state.status = payload.status;
        state.dataHoraSolicitacao = payload.dataHoraSolicitacao;
    },

    listRequest: (state, payload) => {
        //console.log(payload.data);
        state.list = payload.data;
    },

    clearListRequest: (state) => {
        state.list = [];
    }
};

const actions = {
    listRequest: async({ commit }, data) => {
        try {
            const response = await requestService.listRequest(data);
            if (response.length <= 0) {
                throw 'Nenhuma informação encontrada';
            }
            commit('listRequest', response);
        } catch (error) {
            commit('listRequest', []);
            throw error;
        }
    },
    clearListRequest: async({ commit }) => {
        commit('clearListRequest');
    },
    getSolicitacaoById: async({ commit }, id) => {
        const response = await requestService.getSolicitacaoById(id);
        if (response.length <= 0) {
            throw 'Nenhuma informação encontrada';
        }
        commit('get', response.data);
    },

    save: async({ commit }, data) => {
        const response = await requestService.saveFiles(data);
        data.status = response.status;
        if (response.status !== 'OK') {
            data.errors = response.errors;
            //throw 'Erro ao gravar as infomações:'+response.errors.join(', ');
        } else {
            data.idSolicitacao = response.id;
        }
        commit('save', data);
    },
};

export default {
    namespaced: true,
    state,
    getters,
    mutations,
    actions
};